import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer py-5">
            <p className="text-center text-white p-4"><b>copyright@shajjadhossan.web</b></p>
        </div>
    );
};

export default Footer;